<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn depressed color="primary" @click="createClients">
          Создать
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Поиск"
              outlined
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            class="elevation-1 menu-list"
            fixed-header
            :search="search"
            :items-per-page="-1"
            :headers="headers"
            :items="getClientsList"
            :loading="loading"
          >
            <!-- eslint-disable-next-line -->
            <template v-slot:item.name="{ item }">
              <div
                class="text-start"
                :class="{ 'red--text': item.hasActiveBlock }"
                v-text="item.name"
              />
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="accent"
                    class="mr-2"
                    elevation="1"
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="openAddressModal(item.id)"
                  >
                    <!-- eslint-disable-next-line -->
                    <v-icon small>mdi-home-edit</v-icon>
                  </v-btn>
                </template>
                <span>Добавить адрес</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="accent"
                    class="mr-2"
                    elevation="1"
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="goToItem(item.id, true)"
                  >
                    <!-- eslint-disable-next-line -->
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Редактировать</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="accent"
                    class="mr-2"
                    elevation="1"
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="openDeleteModal(item.id)"
                  >
                    <!-- eslint-disable-next-line -->
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Удалить</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="accent"
                    elevation="1"
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="openBlackListDialog(item)"
                  >
                    <!-- eslint-disable-next-line -->
                    <v-icon small>mdi-alert-octagram</v-icon>
                  </v-btn>
                </template>
                <span>
                  <template v-if="!item.hasActiveBlock">
                    В черный список
                  </template>
                  <template v-else>
                    {{ item.hasActiveBlock.name }}
                  </template>
                </span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <!-- Модалка с удалением -->
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            Вы действительно хотите удалить клиента?
          </v-card-title>
          <v-card-text>
            Эту операцию невозможно будет отменить, вы точно хотите удалить
            клиента?
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="closeModal">
              Отмена
            </v-btn>
            <v-btn color="red darken-1" text @click="deleteItem">
              Согласен
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Модалка с блокировкой -->
      <v-dialog v-model="blackListData.dialog" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">
            Добавить клиента в черный список?
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="blackListData.reason"
              outlined
              label="Причина блокировки*"
              required
            />
            <div class="text-h6 mb-2" v-text="'Дата окончания блокировки:'" />
            <v-date-picker
              v-model="blackListData.endBlocking"
              :min="blackListData.blockingMin"
              full-width
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="closeBLModal">
              Отмена
            </v-btn>
            <v-btn
              color="red darken-1"
              text
              :disabled="!blackListData.reason.trim()"
              @click="goToBlackList"
            >
              В черный список
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Модалка с добавлением адреса -->
      <v-dialog v-model="addressData.dialog" persistent max-width="700">
        <v-card>
          <v-card-title class="headline">
            Добавить адрес
          </v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="addressData.data.name"
                    outlined
                    label="Название"
                    required
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="addressData.data.city"
                    outlined
                    label="Город"
                    required
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="addressData.data.street"
                    outlined
                    label="Улица"
                    required
                  />
                </v-col>
                <v-col cols="4" md="2">
                  <v-text-field
                    v-model="addressData.data.house"
                    outlined
                    label="Дом"
                    required
                  />
                </v-col>
                <v-col cols="4" md="2">
                  <v-text-field
                    v-model="addressData.data.entry"
                    outlined
                    label="Подъезд"
                    required
                  />
                </v-col>
                <v-col cols="4" md="2">
                  <v-text-field
                    v-model="addressData.data.apartmentNumber"
                    outlined
                    label="Квартира"
                    required
                  />
                </v-col>
                <v-col cols="12">
                  <v-radio-group v-model="addressData.data.icoName" row>
                    <template v-slot:label>
                      <div>Иконка адреса</div>
                    </template>
                    <v-radio value="home">
                      <template v-slot:label>
                        <v-icon color="orange">
                          mdi-home
                        </v-icon>
                      </template>
                    </v-radio>
                    <v-radio value="heart">
                      <template v-slot:label>
                        <v-icon color="orange">
                          mdi-cards-heart
                        </v-icon>
                      </template>
                    </v-radio>
                    <v-radio value="user-friends">
                      <template v-slot:label>
                        <v-icon color="orange">
                          mdi-account-supervisor
                        </v-icon>
                      </template>
                    </v-radio>
                    <v-radio value="briefcase">
                      <template v-slot:label>
                        <v-icon color="orange">
                          mdi-briefcase
                        </v-icon>
                      </template>
                    </v-radio>
                    <v-radio value="list-alt">
                      <template v-slot:label>
                        <v-icon color="orange">
                          mdi-format-list-bulleted
                        </v-icon>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="closeAddressModal">
              Отмена
            </v-btn>
            <v-btn color="green darken-1" text @click="addAddress">
              Добавить адрес
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar">
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Закрыть
          </v-btn>
        </template>
      </v-snackbar>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        search: '',
        deleteId: null,
        blackListId: null,
        dialog: false,
        dialogBL: false,
        snackbar: false,
        snackText: '',
        blackListData: {
          id: null,
          dialog: false,
          reason: '',
          blockingMin: new Date().toISOString().substr(0, 10),
          endBlocking: new Date().toISOString().substr(0, 10),
        },
        addressData: {
          id: null,
          dialog: false,
          data: {
            city: '',
            street: '',
            house: '',
            entry: '',
            apartmentNumber: '',
            icoName: '',
            name: '',
          },
        },
        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Имя', value: 'name', align: 'start' },
          { text: 'Телефон', value: 'phone', align: 'start' },
          { text: 'Email', value: 'email', align: 'start' },
          { text: 'Действия', value: 'actions', align: 'end', sortable: false },
        ],
        loading: false,
      }
    },
    computed: {
      ...mapGetters({
        getClientsList: 'clients/getClients',
      }),
    },
    async created () {
      try {
        this.loading = true
        await this.$store.dispatch('clients/fetchClientsList', {
          limit: 1000000,
          offset: 0,
          page: 1,
        })
      } catch (error) {
        console.log(error)
      }

      this.loading = false
    },
    methods: {
      openDeleteModal (id) {
        this.deleteId = id
        this.dialog = true
      },
      closeModal () {
        this.deleteId = null
        this.dialog = false
      },
      openBlackListDialog (item) {
        if (!item.hasActiveBlock) {
          this.blackListData.id = item.id
          this.blackListData.dialog = true
        }
      },
      closeBLModal () {
        this.blackListData.id = null
        this.blackListData.dialog = false
      },
      deleteItem () {
        this.$store.dispatch('clients/deleteClients', this.deleteId)
        this.dialog = false
      },
      goToItem (id) {
        this.$router.push({
          name: 'Клиент',
          params: { id: id },
        })
      },
      goToBlackList () {
        const data = {
          reason: this.blackListData.reason,
          endBlocking: this.blackListData.endBlocking,
        }
        const id = this.blackListData.id

        this.$store.dispatch('clients/toBlackListClients', { data, id })
        this.blackListData.dialog = false
      },
      createClients () {
        this.$router.push('/clients/create')
      },
      openAddressModal (id) {
        this.addressData.id = id
        this.addressData.dialog = true
      },
      closeAddressModal () {
        this.addressData.data = {
          city: '',
          street: '',
          house: '',
          entry: '',
          apartmentNumber: '',
          icoName: '',
          name: '',
        }
        this.addressData.id = null
        this.addressData.dialog = false
      },
      addAddress () {
        const data = this.addressData.data
        const id = this.addressData.id
        this.$store
          .dispatch('clients/addAddressClients', { data, id })
          .then((res) => {
            this.addressData.dialog = false
            this.snackText = 'Адрес успешно добавлен'
            this.snackbar = true
          })
          .catch((err) => {
            this.snackText = err.response.data.message
            this.snackbar = true
          })
      },
    },
  }
</script>
